// POST Spokes
export const POST_SPOKE_REQUEST = "POST_SPOKE_REQUEST";
export const POST_SPOKE_SUCCESS = "POST_SPOKE_SUCCESS";
export const POST_SPOKE_FAILURE = "POST_SPOKE_FAILURE";

// List Spokes
export const FETCH_SPOKE_LIST_REQUEST = "FETCH_SPOKE_LIST_REQUEST";
export const FETCH_SPOKE_LIST_SUCCESS = "FETCH_SPOKE_LIST_SUCCESS";
export const FETCH_SPOKE_LIST_FAILURE = "FETCH_SPOKE_LIST_FAILURE";

// List Spokes
export const FETCH_SPOKE_LIST_LOAD_REQUEST = "FETCH_SPOKE_LIST_LOAD_REQUEST";
export const FETCH_SPOKE_LIST_LOAD_SUCCESS = "FETCH_SPOKE_LIST_LOAD_SUCCESS";
export const FETCH_SPOKE_LIST_LOAD_FAILURE = "FETCH_SPOKE_LIST_LOAD_FAILURE";

//List By Id Spokes
export const FETCH_SPOKE_BY_ID_REQUEST = "FETCH_SPOKE_BY_ID_REQUEST";
export const FETCH_SPOKE_BY_ID_SUCCESS = "FETCH_SPOKE_BY_ID_SUCCESS";
export const FETCH_SPOKE_BY_ID_FAILURE = "FETCH_SPOKE_BY_ID_FAILURE";

//Delete Spokes
export const DELETE_SPOKE_SUCCESS = "DELETE_SPOKE_SUCCESS";
export const DELETE_SPOKE_REQUEST = "DELETE_SPOKE_REQUEST";
export const DELETE_SPOKE_FAILURE = "DELETE_SPOKE_FAILURE";